import { render, staticRenderFns } from "./SruItem.vue?vue&type=template&id=0dfd900d&"
import script from "./SruItem.vue?vue&type=script&lang=js&"
export * from "./SruItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports